import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "isDisabled", "hasError", "children"];
import React from 'react';
import pt from 'prop-types';
import { Text } from '../';
import { appendHtmlClass, extendProps } from '../../js/util';
import './_index.scss';
var Label = function Label(props) {
  var className = props.className,
    isDisabled = props.isDisabled,
    hasError = props.hasError,
    children = props.children,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  className = appendHtmlClass(className, 'label');
  if (isDisabled) className = appendHtmlClass(className, 'disabled');
  if (hasError) className = appendHtmlClass(className, 'error');
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    as: "label",
    className: className
  }, rest), children);
};
Object.assign(Label, extendProps(Text, ['align', 'className', 'id', 'color', 'children', 'style'], {
  /**
   * Flag to indicate disabled state; to use along with disabled input
   */
  isDisabled: pt.bool,
  /**
   * Flag to indicate error state; to use along with invalid input
   */
  hasError: pt.bool,
  /**
   * HTML attribute "for" to indicate "id" of referenced input
   */
  htmlFor: pt.string
}, {
  isDisabled: false,
  hasError: false,
  htmlFor: null
}));
export default Label;